import { Link } from "react-router-dom";

import { useContext } from "react";
import { DarkModeContext } from "../DarkModeProvider";

const EmailSended = () => {

  const { darkMode } = useContext(DarkModeContext);

  return (
    <>
      <section className={darkMode ? "auth dark" : "auth light"}>
        <div className="container">
          <div className="auth__container">
            <h2 className={darkMode ? "dark-text" : "light-text"}>
              Email byl úspěšně odeslán na vaši adresu!
            </h2>
            <Link
              to="/profile"
              className={
                darkMode ? "auth__login dark-text" : "auth__login light-text"
              }
            >
              <span>Zpátky na přihlášení</span>
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default EmailSended;
